<div class='row' [formGroup]="form">

  <div class='col-6'>
    {{product.Name}}, {{product.IdDisplay}}
  </div>

  <div class="col-2">
    <div class="input-group">
      <input class="form-control form-control-sm" formControlName="Quantity"
        [class.nb-form-error]="!form.controls.Quantity.valid" (change)="update()">
    </div>
  </div>

  <div class='col-2'>
    {{getBrutto(product) | nbDecimal }} &euro;
  </div>

  <div class='col-2'>
    {{getProductPrice() | nbDecimal }} &euro;
  </div>

</div>
